import React from 'react'
import { Button } from '@/components/buttons/Button'

const OMNICHANNEL_LEARN_MORE_URL = 'https://www.balto.ai/ai-omnichannel-contact-center-solution/'

export const OmnichannelPromotionButton = () => {
  const handleClick = () => {
    window.open(OMNICHANNEL_LEARN_MORE_URL, '_blank', 'noopener noreferrer')
  }

  return (
    <div className="mt">
      <Button type="button" primary onClick={handleClick}>
        Learn more
      </Button>
    </div>
  )
}
